import { LightPayload } from "../utilities/types";

export const lightService = {
  async controlLights(payload: LightPayload) {
    const response = await fetch(`http://localhost:9378/control`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        device_id: payload.device_id,
        local_key: payload.local_key,
        table_id: payload.table_id,
        action: payload.action,
        ip: payload.ip_address || "Auto",
        // Only present on Stop when a POS table was chosen (or "None"/skip was
        // decided) — see StopwatchContext.stop() and posService.fetchTables().
        ...(payload.billed_hours !== undefined ? { billed_hours: payload.billed_hours } : {}),
        ...(payload.billed_half !== undefined ? { billed_half: payload.billed_half } : {}),
        ...(payload.pos_table_id ? { pos_table_id: payload.pos_table_id } : {}),
        ...(payload.session_label ? { session_label: payload.session_label } : {}),
      }),
    });

    if (response.ok) {
      return await response.json();
    }

    throw new Error("Failed to control lights");
  },
};
